import type { Brand, BrandsDataApiResponse, ParentOrgBrandsApiResponse } from '@@/types/Brands';
import isEmpty from 'lodash/isEmpty';
import { mapApiToBrand, mapBrandToApi } from '@/utils/brands';
import type { BrandsRepository } from '@@/types/BrandsRepository';

export function Brands(): BrandsRepository {
  const mediaClient = useNuxtApp().$clients.getClient('media');

  return {
    async find(clientId: number | string): Promise<Brand> {
      const { data } = await useAuthServiceApiV2<BrandsDataApiResponse>(`/brand_settings/${clientId}`, {
        method: 'GET',
      });
      return mapApiToBrand(data);
    },

    async saveBrand(clientId: number | string, brand: Brand): Promise<void> {
      await useAuthServiceApiV2(`/brand_settings/${clientId}`, {
        method: 'PUT',
        body: mapBrandToApi(brand),
      });
    },
    async saveBlob(clientId: number | string, _formData: Blob): Promise<Brand> {
      const { data } = await useAuthServiceApiV2<BrandsDataApiResponse>(`/brand_settings/${clientId}`, {
        method: 'PATCH',
        body: _formData,
      });

      return mapApiToBrand(data);
    },

    async fetchParentOrgSettings(parentOrgId: number) {
      const { data } = await mediaClient.get<ParentOrgBrandsApiResponse>(`/p/brand_settings_export/${parentOrgId}`);
      if (isEmpty(data)) {
        throw new Error('No brand settings found for parent org');
      }
      return mapApiToBrand(data);
    },
  };
}
